// Guarda access_token/refresh_token em localStorage (sobrevive fechar o navegador — "manter
// conectado") ou sessionStorage (some ao fechar a aba) dependendo da escolha feita no login.
// Isolado num módulo à parte porque tanto api/axios.js quanto contexts/AuthContext.jsx
// precisam ler/escrever os tokens, e nenhum dos dois deveria saber ONDE eles moram.
const KEY_ACCESS = 'access_token';
const KEY_REFRESH = 'refresh_token';

function storageAtiva() {
  // localStorage só "ganha" se realmente tiver um token — evita uma aba antiga com
  // sessionStorage preenchido esconder um login "sem manter conectado" mais recente.
  return localStorage.getItem(KEY_ACCESS) ? localStorage : sessionStorage;
}

export function setTokens(accessToken, refreshToken, manterConectado) {
  const destino = manterConectado ? localStorage : sessionStorage;
  const outro = manterConectado ? sessionStorage : localStorage;
  destino.setItem(KEY_ACCESS, accessToken);
  destino.setItem(KEY_REFRESH, refreshToken);
  outro.removeItem(KEY_ACCESS);
  outro.removeItem(KEY_REFRESH);
}

export function getAccessToken() {
  return storageAtiva().getItem(KEY_ACCESS);
}

/** Reescreve o par de tokens (ex: após um refresh) na MESMA storage que já estava em uso —
 * sem precisar saber de novo se era "manter conectado" ou não. */
export function updateTokens(accessToken, refreshToken) {
  const destino = storageAtiva();
  destino.setItem(KEY_ACCESS, accessToken);
  destino.setItem(KEY_REFRESH, refreshToken);
}

export function getRefreshToken() {
  return storageAtiva().getItem(KEY_REFRESH);
}

export function clearTokens() {
  localStorage.removeItem(KEY_ACCESS);
  localStorage.removeItem(KEY_REFRESH);
  sessionStorage.removeItem(KEY_ACCESS);
  sessionStorage.removeItem(KEY_REFRESH);
}
